<template>
    <div
        class="col-lg-3 hidden-md-down minicart-wrap"
        data-element="minicart-wrap"
        ref="wrap"
    >
        <div
            class="minicart-cont"
            :class="{active: fixed, btm: bottom}"
            data-element="minicart"
            ref="cart"
        >
            <slot name="miniCart"></slot>
            <slot name="portingForm"></slot>
            <slot name="nowBuying"></slot>
        </div>
    </div>
</template>

<script>
/* global $ */

export default {
    name: "Aside",
    data () {
        return {
            fixed: false,
            bottom: false
        }
    },
    mounted () {

        $(document).on('click', '.city-link, .chosen-city', function() {
          setTimeout(function() {
            $(window).resize();
          }, 900);
        });

        $(this.$refs.wrap).waypoint((dir) => {
            if (dir === "down") {
                this.fixed = true;
            } else {
                this.fixed = false;
            }
        }, {offset: 0});
      $(this.$refs.wrap).waypoint((dir) => {
        if (dir === "down") {
          this.bottom = true;
        } else {
          this.bottom = false;
        }
      }, {offset: function() {
          return (-$('.minicart-wrap').innerHeight() + $('.minicart-cont').innerHeight());
        }});
    }
}

$(function () {
  var interval = setInterval(function () {
    if ($('.minicart-wrap').length && $('.numbers-group .numbers-items__item').length) {
      $(window).resize();
      clearTimeout(interval);
    }
  }, 200);
});
</script>

<style scoped>

</style>